import { UsageTypeStatusEnum } from '@monetize/types/app';

export const USAGE_TYPE_STATUS_DISPLAY: {
  [key in UsageTypeStatusEnum]: string;
} = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};
